import React, { useEffect, useState } from "react";
import "./AddDelivery.scss";
import InputField from "../../../../components/InputField/InputField";
import { useForm } from "react-hook-form";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../../constants/routes";
import {
  addDelivery,
  deleteDelivery,
  updateDelivery,
} from "../../../../api/delivery";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import useUserIsAllowed from "../../../../helpers/userAuthorized";
import {
  addNewDelivery,
  removeDelivery,
  updateExistingDelivery,
} from "../../../../redux/features/organization-slice";
import DeleteModal from "../../../../components/DeleteModal/DeleteModal";

const AddDelivery = ({ isEdit, desktopView, selected, setSelectedTab }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({});

  const [submitting, setSubmitting] = useState(false);
  const [deliveryId, setDeliveryId] = useState(null);

  const [openDelete, setOpenDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToAddEditDelivery =
    userIsAdministrator || userIsAllowedToManageInventory;

  useEffect(() => {
    const editData =
      desktopView && isEdit ? selected : isEdit ? location.state?.editData : {};
    if (isEdit) {
      if (!editData?.id) {
        setSelectedTab && setSelectedTab("Delivery Rates");
        !desktopView && navigate(ROUTES.deliverySettings.path);
      } else {
        setDeliveryId(editData?.id);
        reset({
          name: editData?.name,
          amount: editData?.amount,
        });
      }
    } else {
      setDeliveryId(null);
      reset({
        name: "",
        amount: "",
      });
    }
  }, [isEdit, selected, location]);

  const handleAddDelivery = (data) => {
    const deliveryData = {
      name: data?.name,
      amount: data?.amount,
      organization_id: organization_id,
    };

    setSubmitting(true);

    if (isEdit) {
      deliveryData.id = deliveryId;
      updateDelivery(organization_id, deliveryData)
        .then((res) => {
          dispatch(updateExistingDelivery({ delivery: res.data }));
          toast.dismiss(); toast.success("Delivery rate updated.");
          setSelectedTab && setSelectedTab("Delivery Rates");
          !desktopView && navigate(ROUTES.deliverySettings.path);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss(); toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss(); toast.error("Error while updating delivery rate!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      addDelivery(organization_id, deliveryData)
        .then((res) => {
          dispatch(addNewDelivery({ delivery: res.data }));
          toast.dismiss(); toast.success("New delivery rate created.");
          setSelectedTab && setSelectedTab("Delivery Rates");
          !desktopView && navigate(ROUTES.deliverySettings.path);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss(); toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss(); toast.error("Error while adding delivery rate!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const handleDelete = () => {
    if (deliveryId) {
      setDeleting(true);
      deleteDelivery(deliveryId)
        .then((res) => {
          dispatch(removeDelivery({ category: { id: deliveryId } }));
          setOpenDelete(false);
          setSelectedTab && setSelectedTab("Delivery Rates");
          !desktopView && navigate(ROUTES.deliverySettings.path);
          toast.dismiss(); toast.success("Delivery deleted successfully.");
        })
        .catch((err) => {
          toast.dismiss(); toast.error("Error while deleting delivery!");
        })
        .finally(() => {
          setDeleting(false);
        });
    }
  };
  return (
    <>
      <div className="add-delivery">
        <form
          aria-disabled={!userIsAllowedToAddEditDelivery}
          className="container-wrapper"
          onSubmit={handleSubmit(handleAddDelivery)}
        >
          <div className="form-container">
            <InputField
              name={"name"}
              type={"text"}
              label={"Delivery Name*"}
              required={true}
              register={register}
              inputErrors={errors}
              watch={watch}
              disabled={!userIsAllowedToAddEditDelivery}
            />

            <InputField
              name={"amount"}
              type={"number"}
              label={"Amount*"}
              required={true}
              register={register}
              inputErrors={errors}
              watch={watch}
              constraints={{
                min: 0,
              }}
              disabled={!userIsAllowedToAddEditDelivery}
            />

            <CustomButton
              name={isEdit ? "Edit Delivery" : "Create Delivery"}
              color={"primary"}
              type={"submit"}
              handleSubmit={() => {}}
              disabled={submitting || !userIsAllowedToAddEditDelivery}
              bigButton={true}
              loader={submitting}
            />

            {isEdit ? (
              <CustomButton
                name={"Delete Category"}
                color={"danger"}
                type={"button"}
                handleSubmit={() => {
                  setOpenDelete(true);
                }}
                disabled={submitting || !userIsAllowedToAddEditDelivery}
                bigButton={true}
              />
            ) : (
              <></>
            )}
          </div>
        </form>
      </div>
      <DeleteModal
        deleting={deleting}
        handleDelete={handleDelete}
        name={`Delivery`}
        open={openDelete}
        setOpen={setOpenDelete}
      />
    </>
  );
};

export default AddDelivery;
